import { useIntl } from 'react-intl'

import { Button } from '../../../components/Button'
import { useAuth } from '../../../contexts/AuthContext'
import { useExpertQuery } from '../../../services/hooks/experts/queries/useExpertQuery'
import { PersonTypeChangeAlert } from './components/PersonTypeChangeAlert'
import { NaturalPersonEditView } from './components/NaturalPersonEditView'
import { LegalPersonEditView } from './components/LegalPersonEditView'
import { InternationalPersonEditView } from './components/InternationalPersonEditView'
import { usePersonalData } from './usePersonalData'

export const PersonalData = () => {
  const { user } = useAuth()
  const { data: expert } = useExpertQuery(user!.id)
  const { formatMessage } = useIntl()
  const {
    isChangingPersonType,
    selectedPersonType,
    isPersonTypeChangeAlertVisible,
    setIsPersonTypeChangeAlertVisible,
    handleChangePersonType,
    handleOpenPersonTypeChangeAlert,
  } = usePersonalData(expert)

  const currentPersonType = expert?.personType
  const isNaturalPerson = currentPersonType === 'natural_person'
  const isLegalPerson = currentPersonType === 'legal_person'
  const isInternationalPerson = currentPersonType === 'international_person'

  return (
    <div className="w-full lg:px-52">
      <div className="mb-10">
        <h2 className="mb-3 text-lg">{expert?.name}</h2>
        <h3 className="mb-6 text-grey-700">{expert?.email}</h3>

        <div className="mb-6">
          <p className="max-w-[622px] text-sm font-normal text-grey-800 ">
            {formatMessage({ id: 'IN_THE_CURRENT_CONFIGURATION' })}{' '}
            <b className="text-sm font-bold text-primary-light ">
              {isNaturalPerson && formatMessage({ id: 'NATURAL_PERSON' })}
              {isLegalPerson && formatMessage({ id: 'LEGAL_PERSON' })}
              {isInternationalPerson &&
                formatMessage({ id: 'INTERNATIONAL_PERSON' })}
            </b>
            {'. '}
            {formatMessage({ id: 'IF_YOU_WANT_CHANGE_TO_ANOTHER_PAYMENT' })}
          </p>
        </div>

        {/* <div className="flex gap-3">
          {!isNaturalPerson && (
            <Button
              variant="outline"
              onClick={() => handleOpenPersonTypeChangeAlert('natural_person')}
            >
              {formatMessage({ id: 'NATURAL_PERSON' })}
            </Button>
          )}

          {!isLegalPerson && (
            <Button
              variant="outline"
              onClick={() => handleOpenPersonTypeChangeAlert('legal_person')}
            >
              {formatMessage({ id: 'LEGAL_PERSON' })}
            </Button>
          )}

          {!isInternationalPerson && (
            <Button
              variant="outline"
              onClick={() =>
                handleOpenPersonTypeChangeAlert('international_person')
              }
            >
              {formatMessage({ id: 'INTERNATIONAL' })}
            </Button>
          )}
        </div> */}
      </div>

      {isNaturalPerson && <NaturalPersonEditView expert={expert} />}
      {isLegalPerson && <LegalPersonEditView expert={expert} />}
      {isInternationalPerson && <InternationalPersonEditView expert={expert} />}

      <PersonTypeChangeAlert
        isChangingPersonType={isChangingPersonType}
        isOpen={isPersonTypeChangeAlertVisible}
        newPersonType={selectedPersonType}
        onClose={() => setIsPersonTypeChangeAlertVisible(false)}
        onChangePersonType={handleChangePersonType}
      />
    </div>
  )
}
